import { Box, Avatar } from "@mui/material";
import { useCallback, memo, useState, useEffect } from "react";
import CustomDivider from "../divider/Divider";
import Button from "../button/Button";
import { getBtnTxt, openBtnTxt } from "../messages";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  handleOpenAppDetailDialogAndPassDetails,
  handleOpenAppDialog,
} from "../constants";
import { loaderImg } from "../images";
import TruncatedTextTooltip from "../TruncatedTextTooltip";

const List = ({
  data,
  idx,
  dataLength,
  setIsDrawerOpen,
  setSelectedId,
  isShowButton = true,
  isFrom = "",
  sx = null,
  isMainListPage = true,
  isDisabled = false,
}) => {
  const [imgSrc, setImgSrc] = useState(null);

  const {
    display_name,
    description,
    logo_images,
    is_app_installed,
    id,
    app_url,
    background_color,
  } = data;

  useEffect(() => {
    setImgSrc(logo_images?.original);
  }, [logo_images]);

  const handleOpenDetailPage = useCallback(() => {
    if (is_app_installed || isFrom === "myApps") {
      handleOpenAppDialog({
        data,
      });
    } else {
      handleOpenAppDetailDialogAndPassDetails({
        id,
      });
    }
  }, [id, app_url, background_color, display_name]);

  const btnProps = {
    label: is_app_installed ? openBtnTxt : getBtnTxt,
    fullWidth: false,
    variant: is_app_installed ? "contained" : "outlined",
    className: "get-button",
    sx: { color: is_app_installed ? "#ffffff" : "#003acc" },
    textClass: "font-12",
    onClick: (e) => {
      if (!isDisabled) {
        e.stopPropagation();
        handleOpenDetailPage(!is_app_installed);
      }
    },
  };

  const myAppsBtnProps = {
    label: openBtnTxt,
    fullWidth: false,
    variant: "contained",
    className: "get-button",
    sx: { color: "#ffffff" },
    textClass: "font-12",
    onClick: (e) => {
      if (!isDisabled) {
        e.stopPropagation();
        handleOpenDetailPage(false);
      }
    },
  };

  return (
    <>
      <Box
        className="list-box"
        sx={{
          ...(sx || {}),
          cursor: isDisabled ? "default" : "pointer",
          ...(isDisabled && { opacity: "0.5" }),
        }}
        onClick={() => {
          if (!isDisabled) handleOpenDetailPage();
        }}
      >
        <Box display="flex" gap="10px">
          <Avatar
            src={imgSrc || loaderImg}
            alt={display_name}
            className="list-avatar"
            variant="rounded"
            onError={() => {
              setImgSrc(loaderImg);
            }}
          />
          <Box
            className="list-content text-truncate"
            sx={{ wordBreak: "break-all" }}
          >
            <TruncatedTextTooltip
              textProps={{
                className: "default-text",
                font: "semibold",
              }}
              textValue={display_name}
              fontSize={16}
            />
            <TruncatedTextTooltip
              textProps={{
                className: "grey-text",
                font: "regular",
              }}
              textValue={description}
              fontSize={12}
            />
          </Box>
        </Box>
        {isMainListPage ? (
          !!isShowButton && (
            <Button {...(isFrom === "myApps" ? myAppsBtnProps : btnProps)} />
          )
        ) : (
          <MoreVertIcon
            onClick={(e) => {
              e.stopPropagation();
              setIsDrawerOpen?.(true);
              setSelectedId?.(id);
            }}
            style={{ cursor: isDisabled ? "default" : "pointer" }}
          />
        )}
      </Box>
      {idx < dataLength - 1 && (
        <CustomDivider sx={{ ml: "83px", mr: "15px" }} />
      )}
    </>
  );
};

export default memo(List);
